(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const contactUsSubmit = document.querySelector('.ContactUsForm button.FormItem-action');
    if (contactUsSubmit) contactUsSubmit.classList.add('Spotlight', 'Spotlight-button');
    let buttons = document.querySelectorAll('.Spotlight');
    // Adding tabindex makes non-focusable elements focusable.  Change this offset to avoid conflicts
    const tabIndexOffset = 100;
    buttons.forEach((btn, i) => {
      btn.setAttribute('tabindex', tabIndexOffset + i);
      btn.addEventListener('mousemove', ({ clientX, clientY, target }) => {
        let { x: rectX, y: rectY } = target.getBoundingClientRect();
        let x = clientX - rectX;
        let y = clientY - rectY;
        btn.style.setProperty('--x', x + 'px');
        btn.style.setProperty('--y', y + 'px');
      });
    });
  })
})();